import { createFileRoute } from '@tanstack/react-router';
import { PersonLiveNotificationsRoute } from './-route-wrappers';

/** One live notification, beneath the person profile's Live notifications tab (FPS-4855). */
function PersonLiveNotificationRoute() {
  const { conversationId } = Route.useParams();

  return <PersonLiveNotificationsRoute conversationId={conversationId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/people/$personId/live-notifications/$conversationId',
)({
  component: PersonLiveNotificationRoute,
});
